<template>
  <Progressbar v-if="loading" />
  <NetworkError v-else-if="errors" @tryAgain="getSendOrders()" />
  <div class="flex flex-col w-full h-full" v-else>
    <div class="alert bg-green-custom-4 text-white">
      <span class="mx-auto">{{ __('The schedule for sending orders to cities') }}</span>
    </div>
    <div class="card mt-3 bg-white" v-if="sendOrders.data.length">
      <div class="card-body py-0 px-1 md:px-0">
        <div class="overflow-x-auto">
          <!-- <table class="table w-full mb-4 bg-white">
            <tbody>
              <tr>
              <th class="w-6/12">{{ __('Sales Expert') }}</th>
              <td class="w-6/12">{{ item.expert }}</td>
            </tr>
            <tr v-for="field in item.fields">
              <th class="w-6/12">{{ field.day }}</th>
              <td class="w-6/12">{{ field.city }}</td>
            </tr>
            </tbody>
          </table> -->
          <table class="table w-full table-compact md:table-normal">
            <thead class="border-b">
              <tr>
                <th>{{ __('Days of the week') }}</th>
                <th>{{ __('Sales Expert') }}</th>
                <th>{{ __('Cities') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="field in sendOrders.data">
                <td>{{ field.day }}</td>
                <td>{{ field.expert }}</td>
                <td>{{ field.city }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <NotFound v-else />
    <div class="alert bg-gray-custom-1 md:mt-4 text-justify" v-if="sendOrders.description">
      <span class="mx-auto text-white" v-html="sendOrders.description"></span>
    </div>
  </div>
</template>

<script setup>
import useProducts from "../../../composables/shop/product";
import { onMounted } from "vue";

const { loading, sendOrders, errors, getSendOrders } = useProducts();

onMounted(() => getSendOrders())
</script>